/*
 * Copyright (c) 2025 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import ArgosDialog from "../../../../../../components/Dialogs/ArgosDialog"
import ArgosFlexbox from "../../../../../../components/Containers/ArgosFlexbox";
import {Typography} from "@mui/material";
import ArgosButton from "../../../../../../components/Buttons/ArgosButton";

interface IProps {
  open: boolean;
  message: string;
  onClose: () => void;
  resetButKeepRedLineData: () => void;
  resetAll: () => void;
}

const ResetSensorsToAdasBomDialog = (props: IProps) => {

  return (
    <ArgosDialog
      height={'auto'}
      width={'auto'}
      open={props.open}
      headerTitle={'Warning'}
      headerTitleAlign={'left'}
    >
      <ArgosFlexbox vertical style={{padding: '20px'}}>
        <ArgosFlexbox vertical style={{padding: '20px'}}>
          <Typography variant='body1'>
            {props.message}
          </Typography>
        </ArgosFlexbox>
        <ArgosFlexbox style={{display: 'flex', flexDirection: 'row', padding: '10px'}}>
          <ArgosButton
            id={`cancel-button`}
            data-testid={`cancel-button`}
            variant="contained"
            size="large"
            fontSize={16}
            onClick={props.onClose}
          >
            Cancel
          </ArgosButton>
          <ArgosButton
            id={`reset-but-keep-red-line-data-button`}
            data-testid={`reset-but-keep-red-line-data-button`}
            variant="text"
            size="large"
            fontSize={16}
            onClick={props.resetButKeepRedLineData}
          >
            Reset But Keep Red Line Data
          </ArgosButton>
          <ArgosButton
            id={`reset-all-button`}
            data-testid={`reset-all-button`}
            variant="text"
            size="large"
            fontSize={16}
            onClick={props.resetAll}
          >
            Reset All
          </ArgosButton>
        </ArgosFlexbox>
      </ArgosFlexbox>
    </ArgosDialog>
  )
}

export default ResetSensorsToAdasBomDialog